import DOMPurify from "dompurify";

/**
 * Sanitize HTML to prevent XSS attacks.
 * Strips <script>, <style>, event-handler attributes, and dangerous URIs.
 */
export function sanitizeHtml(dirty: string): string {
  return DOMPurify.sanitize(dirty, {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ["style"],
    // Allow style attribute so inline styles (e.g. line-height for compact lists) survive.
    // DOMPurify still strips JS expressions and dangerous CSS values automatically.
    // Allow target="_blank" so external links open in a new tab.
    // DOMPurify auto-adds rel="noopener noreferrer" to links with target="_blank".
    ADD_ATTR: ["target"],
  });
}
